import { Redirect, Route } from "react-router";
import { useUser } from "../../utils/Contexts/Context";

function ProtectedRouteWrapper({ path, children }) {
    const { user } = useUser();
    return <Route path={path}>{user ? children : <Redirect to="/" />}</Route>;
}

export default ProtectedRouteWrapper;
